import { Button, Tooltip } from "@mui/material";
import { __APP_SHADOW_ROOT } from "@src/v3.0.0";
import { useCropperStore } from "@src/v3.0.0/store/cropper/cropper-store";
import { useFurnituresStore } from "@src/v3.0.0/store/furnitures/store";
import { useRef } from "react";
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto';
export function CreateScreenshot() {
  const {items} = useFurnituresStore();
  const cropperStore = useCropperStore();
  const xmls = useRef(new XMLSerializer);

  const drawOnCropper = (images) => new Promise(resolve => {
    const preset = cropperStore.preset;
    /** --- contesto con immagine a dimensioni naturali e non ridotte, o comunque che differiscono da ciò che si vede */
    const ctx = cropperStore.element.cropper.getCroppedCanvas().getContext('2d');
    /** --- disegno delle immagini sulla cropped canvas */
    for(let i = 0; i <= images.length-1; i++) {
      const imageDefinition = images[i];
      if (imageDefinition) {
        const {image, uid} = imageDefinition;
        const item = items.filter(i => i.uid === uid)[0];

        const itemWidthPx = ctx.canvas.width/(preset.width/item.widthCm);
        const itemHeightPx = ctx.canvas.height/(preset.height/item.heightCm);
        const itemPosX   = (ctx.canvas.width/100)*item.x;
        const itemPosY   = (ctx.canvas.height/100)*item.y;

        ctx.drawImage(image, itemPosX, itemPosY, itemWidthPx, itemHeightPx);
      }
    }
    resolve(ctx.canvas);
  });

  const loadImage = (item) => new Promise(resolve => {
    const uid = item.getAttribute('data-furniture-uid');
    const svg = item.querySelector('.furniture-img-container svg');
    const serialized = xmls.current.serializeToString(svg);
    const base64 = btoa(serialized);
    const image = new Image();
    image.src = 'data:image/svg+xml;base64,' + base64;
    image.onload = () => {
      resolve({ image, uid });
    };
    image.onerror = () => {
      resolve(null);
    };
  });

  const createImages = () => new Promise(async resolve => {
    const domItems = __APP_SHADOW_ROOT.querySelectorAll('[data-furniture-uid]');
    const images = [];
    for(let i = 0; i <= domItems.length-1; i++) {
      const loadedImage = await loadImage(domItems[i]);
      images.push(loadedImage);
    }
    resolve(images);
  });

  const downloadScreenshot = dataURL => {
    // Crea un link per il download
    const link = document.createElement('a');
    link.href = dataURL;
    link.download = 'ritaglio.png'; // Nome del file che verrà scaricato
    link.click(); // Simula il click per scaricare l'immagine
  }

  const onSaveScreenshot = async () => {
    if (cropperStore.element) {
      console.clear();
      const images = await createImages();
      const canvas = await drawOnCropper(images);
      const dataURL = canvas.toDataURL("image/png");
      downloadScreenshot(dataURL);
    }
  };

  return (
    <Tooltip title="Salva il render come immagine">
      <span>
        <Button 
          startIcon={<AddAPhotoIcon />} 
          onClick={onSaveScreenshot}
          disabled={items.length <= 0}
        >Screenshot</Button>
      </span>
    </Tooltip>
  )
}